(function () {
  'use strict';

  if (window.__fabTouchAttribution) return;

  var COOKIE_NAME = '_fab_touch';
  var MAX_AGE_SEC = 60 * 60 * 24 * 30;
  var MAX_AGE_MS = MAX_AGE_SEC * 1000;
  var TOUCH_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'gclid',
    'ttclid'
  ];

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value) {
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; Path=/' +
      '; Domain=.fab-art.co' +
      '; Max-Age=' +
      MAX_AGE_SEC +
      '; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }

  function parseTouch(raw) {
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!data || typeof data.ts !== 'number') return null;
      if (Date.now() - data.ts > MAX_AGE_MS) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function getTouch() {
    return parseTouch(getCookie(COOKIE_NAME));
  }

  function landingHasTrigger(params) {
    return !!(
      params.get('utm_source') ||
      params.get('fbclid') ||
      params.get('gclid') ||
      params.get('ttclid')
    );
  }

  function captureFromSearch(search) {
    if (!search) return null;
    var params;
    try {
      params = new URLSearchParams(search.charAt(0) === '?' ? search.slice(1) : search);
    } catch (e) {
      return null;
    }
    if (!landingHasTrigger(params)) return null;

    var payload = { ts: Date.now() };
    TOUCH_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) payload[key] = value;
    });

    if (Object.keys(payload).length <= 1) return null;
    return payload;
  }

  function captureLanding() {
    try {
      if (getTouch()) return;
      var payload = captureFromSearch(window.location.search);
      if (!payload) return;
      setCookie(COOKIE_NAME, JSON.stringify(payload));
    } catch (e) {}
  }

  window.__fabTouchAttribution = {
    COOKIE_NAME: COOKIE_NAME,
    TOUCH_KEYS: TOUCH_KEYS,
    getTouch: getTouch,
    captureLanding: captureLanding,
    captureFromSearch: captureFromSearch
  };

  captureLanding();
})();
